import { Check, ArrowUpRight } from "lucide-react";

const FINISHES = [
  { id: "obsidian_black", short: "obsidian", label: "Obsidian Black", className: "signal-metal-black" },
  { id: "champagne_gold", short: "gold", label: "Champagne Gold", className: "signal-metal-gold" },
  { id: "chrome_silver", short: "silver", label: "Chrome Silver", className: "signal-metal-silver" },
];

export const SignalReveal = ({ finish, onFinishChange }) => (
  <section id="reveal" data-testid="signal-reveal" className="signal-reveal signal-chapter">
    <div className="signal-container">
      <div className="signal-section-intro">
        <div>
          <h2 className="signal-eyebrow" data-testid="signal-materials-label">Finishes</h2>
          <p className="signal-display" data-testid="signal-materials-headline">Three expressions.<br />One Pulse One.</p>
        </div>
        <div className="signal-intro-note" data-testid="signal-reveal-stage"><p>The full design.<br /><strong>Coming soon.</strong></p><p className="signal-small">Finish color studies below.<br />Not product renders.</p></div>
      </div>
      <div className="signal-finish-studies" data-testid="signal-finishes">
        {FINISHES.map((f) => (
          <button type="button" key={f.id} className="signal-finish-study" data-testid={`signal-finish-${f.short}`} aria-pressed={finish === f.id} onClick={() => onFinishChange(f.id)} aria-label={`Prefer ${f.label}`}>
            <span className={`signal-metal ${f.className}`} aria-hidden="true"><span /></span>
            <span className="signal-finish-caption"><span>{f.label}</span><span className="signal-finish-check">{finish === f.id ? <Check size={17} aria-hidden="true" /> : <span className="signal-finish-dot" />}</span></span>
          </button>
        ))}
      </div>
      <div className="signal-finish-footer"><p data-testid="signal-finish-note">Final materials and specifications at the reveal.</p><a href="#transmission" data-testid="signal-materials-waitlist">Join with your preferred finish <ArrowUpRight size={16} aria-hidden="true" /></a></div>
    </div>
  </section>
);